export default (min, max) => (Math.random() * (max - min)) + min;